import React, { memo } from 'react';

const Quizzes = () => {
  return <></>;
};

export default memo(Quizzes);
